<template>
  <el-dialog
    v-if="dialogVisible"
    :key="formKey"
    v-dialogDrag
    :title="type === 'app' ? '应用编辑' : 'LOGO编辑'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="self-dialog-form"
    width="460px"
    append-to-body
  >
    <el-form ref="formRef" :rules="formRules" :model="formData">
      <el-form-item :label="type === 'app' ? '应用名称' : '系统名称'" prop="applicationName">
        <el-input
          v-model.trim="formData.applicationName"
          placeholder="请输入应用名称"
          autocomplete="off"
          :max-length="type === 'app' ? 16 : 32"
        />
      </el-form-item>
      <el-form-item v-if="type === 'app'" label="应用描述" prop="description">
        <el-input
          v-model="formData.description"
          type="textarea"
          :rows="4"
          placeholder="请输入应用描述"
          autocomplete="off"
          :max-length="30"
        />
      </el-form-item>
      <el-form-item prop="remark">
        <div slot="label">导入或拖拽上传图片</div>
        <upload-img
          style="clear: both"
          :property="property"
          @change="handleChangeImg"
          @remove="handleRemoveImg"
        />
      </el-form-item>
      <el-alert
        class="self-alert"
        title="请选择图片，最大支持200k，jpg，jpeg，png"
        type="primary"
        :closable="false"
        show-icon
      />
      <slot name="desc"></slot>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" :loading="propLoading" @click="handleConfirm">
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import UploadImg from "@/components/common/uploadImg";
import { titleDefaultPicture, appDefaultPicture } from "@/utils/base64svg";

export default {
  name: "EditApp",
  components: { UploadImg },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    },
    propLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      formData: {},
      formRules: {
        applicationName: [{ required: true, message: "请输入应用名称", trigger: "blur" }]
      },
      property: {
        accept: ".jpg,.jpeg,.png",
        limit: "200",
        url: ""
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.formKey = new Date().getTime();
        if (val) {
          this.$nextTick(() => {
            this.$refs.formRef && this.$refs.formRef.resetField();
          });
        }
        this.$emit("update:visible", val);
      }
    },
    type() {
      return this.propData.type;
    }
  },
  watch: {
    propData(val) {
      this.$set(this, "formData", val);
      if (this.type === "title") {
        this.formData.applicationName = this.formData.applicationName || this.$t("title.headerTitle");
        this.formData.applicationIcon = this.formData.applicationIcon || titleDefaultPicture;
      }
      this.$set(this.property, "url", val.applicationIcon);
    }
  },
  methods: {
    handleChangeImg(file) {
      this.formData.applicationIcon = "";
      this.formData.file = file;
    },
    handleRemoveImg() {
      this.formData.applicationIcon = "";
      this.formData.file = "";
    },
    // 确认提交
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.type === "app" && !this.formData.applicationIcon && !this.formData.file) {
            this.formData.applicationIcon = appDefaultPicture;
          }
          if (this.type === "title" && !this.formData.applicationIcon && !this.formData.file) {
            this.formData.applicationIcon = titleDefaultPicture;
          }
          this.$emit("confirm", this.formData);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
